export const getEmptyData = ()=>({
    child: {
      lastName: '',
      firstName: '',
      middleName: '',
      birthDate: new Date().toISOString(),
      gender: 'girl',
      birthCertificate: {
        seriesNumber: '',
        issueDate: new Date().toISOString(),
        country: 'ua',
        files:[]
      },
      address: {
        district: '',
        street: '',
        building: '',
        corpus: ''
      },
      addressFact: {
        district: '',
        street: '',
        building: '',
        corpus: ''
      },
      sameFactAddress: "yes"
    },
    applicant: {
      lastName: '',
      firstName: '',
      middleName: '',
      citizenship: 'Україна',
      hasRnokpp: "yes",
      rnokpp: '',
      phone: '',
      email: '',
      address: {
        district: '',
        street: '',
        building: '',
        corpus: ''
      },
      documentType: '',
      documentDetails: ''
    },
    preferences: {
      desiredDate: new Date().toISOString(),
      ageMenu: false,
      inclusiveGroup: false,
      specialization: false,
      diseaseType: '',
      diseaseDocument: {
        type: '',
        number: '',
        issuedTo: '',
        issueDate: '',
        files: []
      }
    },
    benefits: {
      type: '',
      documentType: '',
      documentNumber: '',
      kindergarten:'',
      issuedTo: '',
      issueDate: '',
      files: [],
      address: {
        district: '',
        street: '',
        building: '',
        corpus: ''
      }
    },
    selectedSchools: [],
    agreePersonalData: "no",
    dictionary:{
      addresses:{ corpus:{}, building:{}, street:{}, district:{}},
      kindergartens:{}
    }
  })